import React, { useEffect, useState } from "react";
import { css } from "styled-components";
import { Button, Container, Label, Line } from "../../Styles/Global.Styled";
import InfoIcon from "../../Icons/InfoIcon";
import PasswordHelper from "./PasswordHelper";

const passwordCheck = (password) => [
  {
    rule: "at least one lowercase letter",
    isValid: /[a-z]/.test(password),
  },
  {
    rule: "an uppercase letter",
    isValid: /[A-Z]/.test(password),
  },
  {
    rule: "Includes a number",
    isValid: /\d/.test(password),
  },
  {
    rule: "Includes a special character",
    isValid: /[@$!%*?&_-]/.test(password),
  },
  { rule: "Less than 8 characters", isValid: password.length >= 8 },
];
const getStrengthInfo = (password, validCount) => {
  if (!password) return { label: "Neutral", color: "#999" }; // Neutral state
  if (validCount <= 1) return { label: "Weak", color: "red" };
  if (validCount <= 3) return { label: "Medium", color: "orange" };
  if (validCount === 4) return { label: "Strong", color: "blue" };
  return { label: "Very Strong", color: "green" };
};
const cntStyle = css`
  flex-direction: column;
  margin-top: 1vh;
  width: 100%;
  padding: 0 0.5vh;
  gap: 0.5vh;
`;
const gapSize = css`
  gap: 0.5vh;
`;
const lineColor = (color) => css`
  border-color: ${({ theme }) => color || theme.shadowColor};
`;
const labelStyle = (color) => css`
  display: flex;
  font-size: 1vh;
  align-items: center;
  color: ${({ theme }) => color || theme.shadowColor};
`;

const PasswordStrength = ({ value = "" }) => {
  const [passwordChecks, setChecks] = useState(passwordCheck(value));
  const [strength, setStrength] = useState({ label: "", color: "" });
  const [showHelper, setHelper] = useState(false);

  useEffect(() => {
    const checks = passwordCheck(value);
    setChecks(checks);
    const validCount = checks.filter((c) => c.isValid).length;
    setStrength(getStrengthInfo(value, validCount));
  }, [value]);

  return (
    <Container $baseStyle={cntStyle}>
      <Container $baseStyle={gapSize}>
        {passwordChecks.map((_, index) => (
          <Line
            key={index}
            $baseStyle={lineColor(
              index < passwordChecks.filter((c) => c.isValid).length &&
                strength.color
            )}
          />
        ))}
      </Container>
      <Container>
        <Label $baseStyle={labelStyle(strength.color)}>{strength.label}</Label>
        <Button onClick={() => setHelper(!showHelper)} type="button">
          <InfoIcon />
        </Button>
      </Container>
      {showHelper && <PasswordHelper checks={passwordChecks} />}
    </Container>
  );
};

export default PasswordStrength;
